import React, { useRef, useState } from 'react';
import './information.styles.scss';

import { sanitize } from '@/utils/sanitize';
import TextAreaWordCount from '@/components/SHARED/text-area-word-count/text-area-word-count.component';
import { useSelector } from 'react-redux';
import ImportModal from './import-modal.component';
import Modal, { ModalConfirm } from '@/components/modal/modal.component';
import ModalMyContent from '@/components/SHARED/content-manager/modal-my-content.component';
import useAnalytics from '@/utils/useAnalytics';
import TextEditorNoLib from '@/components/SHARED/text-editor-no-lib/text-editor-no-lib.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const ManageContentInformation = ({
  type,
  saveData,
  formData,
  existingDescription,
  gameElements,
  clearEditor,
  setClearEditor,
  textEditorLabel,
  importChallengeForCheckpoint,
  challengesToImport
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [showImportModal, setShowImportModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const { trackEvent, trackException } = useAnalytics();
  const [importChallenge, setImportChallenge] = useState(null);
  const approveRef = useRef();

  function launchMyContentImport() {
    setConfirmMessage('Are you sure you want to import content from your content library? ' +
      'This will overwrite any existing information you have entered for this element.');
    approveRef.current = () => {
      setShowImportModal(true);
    }
  }

  function importElement(element) {
    console.log(element);
    const keys = [
      'name',
      'desc',
      'icon'
    ]
    Object.keys(element).forEach(key => {
      if (key.includes('opt_')) {
        keys.push(key);
      }
    })
    keys.forEach(key => {
      if (element[key]) {
        saveData(key, element[key]);
      }
    })
    trackEvent(
      'import_element',

    );
    setShowImportModal(false);
  }

  return (
    <div className={`information-form ${screenSize}`}>
      <div className={`g-list-item form-section ${screenSize}`}>
        {/* g-list-item form-section */}
        <div className='information-form-head'>
          <h3>Information</h3>
          {
            (type === 'checkpoint')
            ?
            <button
              className='g-button small-btn'
              onClick={() => setImportChallenge(true)}>
              Import from Challenge
            </button>
            :
            <button
              className='g-button small-btn'
              onClick={() => launchMyContentImport()}>
              {
                screenSize === 'mobile' ? 'Import' : 'Import from My Conent'
              }
            </button>
          }
        </div>
        <hr />
        <div className='field small'>
          <label>{type === 'secretCode' ? 'Secret Code Word(s) - 50 character maximum' : 'Name'}<span className='required'>*</span></label>
          <input
            type='text'
            id='name'
            value={
              formData && formData.name 
              ? formData.name 
              : ''
            }
            onChange={(e) => saveData('name', sanitize(e.target.value.slice(0, 100)))}
          />
        </div>
        <div className="g-space-1"></div>
        <div className='field small'>
          <label>
            {textEditorLabel}
            {
              (type === 'checkpoint' || type === 'challenge') &&
              <span className='required'>*</span>
            }
          </label>
          {
            (formData) &&
              (existingDescription && type === 'challenge')
              ?
              <TextEditorNoLib
                onChange={(e) => saveData('desc', e)}
                initialValue={existingDescription} />
              :
              <TextAreaWordCount
                saveData={saveData}
                count={50}
                keyId="desc"
                existingText={existingDescription ?? ""} />
          }
        </div>
        <div className="g-space-1"></div>
      </div>
      {/* <ImportModal
				show={showImportModal}
				cancel={() => setShowImportModal(false)}
				saveData={saveData} /> */}
      <ModalMyContent
        show={showImportModal}
        cancel={() => setShowImportModal(false)}
        chooseElement={importElement}
        type={type} />
      {
        (importChallenge && challengesToImport) &&
        <Modal
          show={!!importChallenge}
          cancel={() => setImportChallenge(null)}
          text='Import data from an existing Challenge'
          closeButton={true}
          cls='full'>
          <div className='import-challenge-modal'>
            {
              challengesToImport
              .filter(e => e.type === 'challenge')
              .map(challenge => (
                <div
                  key={challenge.id}
                  className='challenge-option g-list-item'
                  onClick={() => importChallengeForCheckpoint(challenge)}>
                  <ImageContainer
                    src={challenge.icon}
                    containerWidth='48px'
                    containerHeight='48px'
                    className='challenge-icon' />
                  {challenge.name}
                  <button className='g-button small-btn'>
                    Import
                  </button>
                </div>
              ))
            }
          </div>
        </Modal> 
      }
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default ManageContentInformation;